export default __webpack_public_path__ + "static/media/sample1.c89a9136.png";